import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getOrderGeneratorsFieldsWorksProducts(companyId, generatorId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].getOrderGeneratorsFieldsWorksProducts,
		{
			urlParams: {
				companyId,
        generatorId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorksProduct(companyId, generatorId, productId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].getOrderGeneratorsFieldsWorksProduct,
		{
			urlParams: {
				companyId,
        generatorId,
				productId,
			},
		}
	)
}

function createOrderGeneratorsFieldsWorksProduct(companyId, generatorId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].createOrderGeneratorsFieldsWorksProduct,
		{
			urlParams: {
				companyId,
        generatorId,
			},
			...payload,
		}
	)
}


function putOrderGeneratorsFieldsWorksProduct(companyId, generatorId, productId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].putOrderGeneratorsFieldsWorksProduct,
		{
			urlParams: {
				companyId,
        generatorId,
				productId,
			},
			...payload,
		}
	)
}

function patchOrderGeneratorsFieldsWorksProduct(companyId, generatorId, productId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].patchOrderGeneratorsFieldsWorksProduct,
		{
			urlParams: {
				companyId,
        generatorId,
				productId,
			},
			...payload,
		}
	)
}

function deleteOrderGeneratorsFieldsWorksProduct(companyId, generatorId, productId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].deleteOrderGeneratorsFieldsWorksProduct,
		{
			urlParams: {
				companyId,
        generatorId,
				productId,
			},
		}
	)
}

export default {
	getOrderGeneratorsFieldsWorksProducts,
	getOrderGeneratorsFieldsWorksProduct,
	createOrderGeneratorsFieldsWorksProduct,
	putOrderGeneratorsFieldsWorksProduct,
	patchOrderGeneratorsFieldsWorksProduct,
	deleteOrderGeneratorsFieldsWorksProduct,
}

